import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const FlowerIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <path
      d="M36 18C36 8.059 27.941 0 18 0C8.059 0 0 8.059 0 18C0 27.941 8.059 36 18 36C27.941 36 36 27.941 36 18Z"
      fill="white"
    />
    <path
      d="M9.28392 17.565C13.1479 17.565 16.4759 19.87 17.9869 23.174C19.4979 19.87 22.8269 17.565 26.6899 17.565H27.0189C27.3909 15.18 26.6889 12.719 24.8249 10.828L21.2139 13.693C19.5369 15.024 18.4589 16.721 17.9869 18.504C17.5149 16.721 16.4379 15.024 14.7599 13.693L11.1489 10.828C9.28593 12.719 8.58292 15.18 8.95592 17.565H9.28392Z"
      fill="#3D3C38"
    />
    <path
      d="M17.9969 16.17C18.6429 14.984 19.5449 13.919 20.6679 13.025C20.0999 11.508 19.2169 10.082 17.9969 8.862C16.7769 10.082 15.8949 11.508 15.3269 13.025C16.4499 13.919 17.3519 14.984 17.9969 16.17Z"
      fill="#FF612B"
    />
    <path
      d="M9.29495 18.436H3.37695C3.37695 23.242 7.27396 27.139 12.08 27.139H17.9969C17.9969 22.332 14.101 18.436 9.29495 18.436Z"
      fill="#FF612B"
    />
    <path
      d="M26.7 18.436C21.894 18.436 17.998 22.332 17.998 27.139H23.915C28.721 27.139 32.618 23.242 32.618 18.436H26.7Z"
      fill="#FF612B"
    />
  </Box>
)

export default FlowerIcon
